import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { getPathPayload } from '@hwm/ui-lib';
import { IAccountSettings, IAccountSettingsPut } from '@models/IAccountSettings';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { MAX_NUM_OF_SITES_SELECT_ALL } from './SettingsReducer';

const getSettings = createAsyncThunk(
  `${EntityReducers.sites}/getSettings`,
  async (payload: getPathPayload<typeof apiPaths.accounts.accountSettings>) => {
    const response: AxiosResponse<IAccountSettings> = await httpClient.get(
      `${apiPaths.accounts.accountSettings(payload)}`
    );

    return {
      ...response.data,
      id: payload.accountId,
      autoCorrelationOptions: {
        ...response.data.autoCorrelationOptions,
        timeToRunAutoCorrelation: response.data.autoCorrelationOptions.timeToRunAutoCorrelation
          ? new Date(response.data.autoCorrelationOptions.timeToRunAutoCorrelation)
          : null,
      },
      maximumSitesForSelectAll: response.data.maximumSitesForSelectAll ?? MAX_NUM_OF_SITES_SELECT_ALL,
    } as IAccountSettings;
  }
);

export interface ISaveSettingsParams extends getPathPayload<typeof apiPaths.accounts.accountSettings> {
  body: IAccountSettingsPut;
}

const saveSettings = createAsyncThunk(
  `${EntityReducers.sites}/saveSettings`,
  async ({ body, accountId }: ISaveSettingsParams) => {
    const response: AxiosResponse<IAccountSettings> = await httpClient.put(
      `${apiPaths.accounts.accountSettings({ accountId })}`,
      {
        ...body,
        autoCorrelationOptions: {
          ...body.autoCorrelationOptions,
          radius: parseFloat(body.autoCorrelationOptions.radius.toString()),
        },
        requestRecordingsOptions: {
          ...body.requestRecordingsOptions,
          radius: parseFloat(body.requestRecordingsOptions.radius.toString()),
        },
        costOptions: {
          ...body.costOptions,
          costPerThousand: parseFloat(body.costOptions.costPerThousand.toString()),
        },
        miscellaneous: {
          ...body.miscellaneous,
          lowMetricBound: parseFloat(body.miscellaneous.lowMetricBound?.toString()),
          topImperialBound: parseFloat(body.miscellaneous.topImperialBound?.toString()),
        },
      } as IAccountSettingsPut
    );

    return {
      ...response.data,
      id: accountId,
    };
  }
);

export const thunks = { getSettings, saveSettings };
